import { EpimsBaseEntityDto } from './epim-base.dto';
export class SeismicSwathCalcDto extends EpimsBaseEntityDto {
  ContractorId: string;
  ProgramId: string;
  OilMineralLeaseId: string;
  SwathId: string;
  BranchCode: string;
  SwathNo: string;
  SubscriptionUserId: string;
  Version: number;
}
